// AUTO-GENERATED from the Chargeback MCP design file. Card + guide content and
// all screenshots/icons live here; rendered by McpGuideModal / McpIntegrations.
// Strings are English keys passed through i18next t() at render time.

import mcp_antigravity_disconnect from "../../../Images/mcp/antigravity_disconnect.png"
import mcp_antigravity_step_1 from "../../../Images/mcp/antigravity_step_1.png"
import mcp_antigravity_step_2 from "../../../Images/mcp/antigravity_step_2.png"
import mcp_antigravity_step_3 from "../../../Images/mcp/antigravity_step_3.png"
import mcp_antigravity_step_4 from "../../../Images/mcp/antigravity_step_4.png"
import mcp_bolt_disconnect from "../../../Images/mcp/bolt_disconnect.png"
import mcp_bolt_step_1 from "../../../Images/mcp/bolt_step_1.png"
import mcp_bolt_step_2 from "../../../Images/mcp/bolt_step_2.png"
import mcp_bolt_step_3 from "../../../Images/mcp/bolt_step_3.png"
import mcp_bolt_step_4 from "../../../Images/mcp/bolt_step_4.png"
import mcp_chatgpt_disconnect from "../../../Images/mcp/chatgpt_disconnect.png"
import mcp_chatgpt_step_1 from "../../../Images/mcp/chatgpt_step_1.png"
import mcp_chatgpt_step_2 from "../../../Images/mcp/chatgpt_step_2.png"
import mcp_chatgpt_step_3 from "../../../Images/mcp/chatgpt_step_3.png"
import mcp_claude_disconnect from "../../../Images/mcp/claude_disconnect.png"
import mcp_claude_step_1 from "../../../Images/mcp/claude_step_1.png"
import mcp_claude_step_2 from "../../../Images/mcp/claude_step_2.png"
import mcp_claude_step_3 from "../../../Images/mcp/claude_step_3.png"
import mcp_claude_step_4 from "../../../Images/mcp/claude_step_4.png"
import mcp_codex_disconnect from "../../../Images/mcp/codex_disconnect.png"
import mcp_codex_step_1 from "../../../Images/mcp/codex_step_1.png"
import mcp_codex_step_2 from "../../../Images/mcp/codex_step_2.png"
import mcp_codex_step_3 from "../../../Images/mcp/codex_step_3.png"
import mcp_codex_step_4 from "../../../Images/mcp/codex_step_4.png"
import mcp_codex_step_5 from "../../../Images/mcp/codex_step_5.png"
import mcp_cursor_disconnect from "../../../Images/mcp/cursor_disconnect.png"
import mcp_cursor_step_1 from "../../../Images/mcp/cursor_step_1.png"
import mcp_cursor_step_2 from "../../../Images/mcp/cursor_step_2.png"
import mcp_cursor_step_3 from "../../../Images/mcp/cursor_step_3.png"
import mcp_devin_disconnect from "../../../Images/mcp/devin_disconnect.png"
import mcp_devin_step_1 from "../../../Images/mcp/devin_step_1.png"
import mcp_devin_step_2 from "../../../Images/mcp/devin_step_2.png"
import mcp_devin_step_3 from "../../../Images/mcp/devin_step_3.png"
import mcp_devin_step_4 from "../../../Images/mcp/devin_step_4.png"
import mcp_devin_step_5 from "../../../Images/mcp/devin_step_5.png"
import mcp_devin_step_6 from "../../../Images/mcp/devin_step_6.png"
import mcp_gemini_step_5 from "../../../Images/mcp/gemini_step_5.png"
import mcp_grok_disconnect from "../../../Images/mcp/grok_disconnect.png"
import mcp_grok_step_1 from "../../../Images/mcp/grok_step_1.png"
import mcp_grok_step_2 from "../../../Images/mcp/grok_step_2.png"
import mcp_grok_step_3 from "../../../Images/mcp/grok_step_3.png"
import mcp_grok_step_4 from "../../../Images/mcp/grok_step_4.png"
import mcp_icon_antigravity_ide from "../../../Images/mcp/icon_antigravity_ide.png"
import mcp_icon_chatgpt_dark from "../../../Images/mcp/icon_chatgpt_dark.svg"
import mcp_icon_chatgpt from "../../../Images/mcp/icon_chatgpt.png"
import mcp_icon_claude_code from "../../../Images/mcp/icon_claude_code.png"
import mcp_icon_claude from "../../../Images/mcp/icon_claude.png"
import mcp_icon_codex_by_openai from "../../../Images/mcp/icon_codex_by_openai.jpg"
import mcp_icon_cursor_dark from "../../../Images/mcp/icon_cursor_dark.svg"
import mcp_icon_cursor from "../../../Images/mcp/icon_cursor.png"
import mcp_icon_devin_web from "../../../Images/mcp/icon_devin_web.png"
import mcp_icon_grok_dark from "../../../Images/mcp/icon_grok_dark.svg"
import mcp_icon_grok from "../../../Images/mcp/icon_grok.svg"
import mcp_icon_integration_missing from "../../../Images/mcp/icon_integration_missing.svg"
import mcp_icon_mistral_ai from "../../../Images/mcp/icon_mistral_ai.png"
import mcp_icon_more_integrations from "../../../Images/mcp/icon_more_integrations.svg"
import mcp_lovable_disconnect from "../../../Images/mcp/lovable_disconnect.png"
import mcp_lovable_step_1 from "../../../Images/mcp/lovable_step_1.png"
import mcp_lovable_step_2 from "../../../Images/mcp/lovable_step_2.png"
import mcp_lovable_step_3 from "../../../Images/mcp/lovable_step_3.png"
import mcp_lovable_step_4 from "../../../Images/mcp/lovable_step_4.png"
import mcp_mistral_disconnect from "../../../Images/mcp/mistral_disconnect.png"
import mcp_mistral_step_1 from "../../../Images/mcp/mistral_step_1.png"
import mcp_mistral_step_2 from "../../../Images/mcp/mistral_step_2.png"
import mcp_mistral_step_3 from "../../../Images/mcp/mistral_step_3.png"
import mcp_v0_disconnect from "../../../Images/mcp/v0_disconnect.png"
import mcp_v0_step_1 from "../../../Images/mcp/v0_step_1.png"
import mcp_v0_step_2 from "../../../Images/mcp/v0_step_2.png"
import mcp_v0_step_3 from "../../../Images/mcp/v0_step_3.png"
import mcp_v0_step_4 from "../../../Images/mcp/v0_step_4.png"
import mcp_v0_step_5 from "../../../Images/mcp/v0_step_5.png"
import mcp_vscode_disconnect from "../../../Images/mcp/vscode_disconnect.png"
import mcp_vscode_step_1 from "../../../Images/mcp/vscode_step_1.png"
import mcp_vscode_step_2 from "../../../Images/mcp/vscode_step_2.png"
import mcp_vscode_step_4 from "../../../Images/mcp/vscode_step_4.png"
import mcp_vscode_step_5 from "../../../Images/mcp/vscode_step_5.png"
import mcp_vscode_step_6 from "../../../Images/mcp/vscode_step_6.png"
import mcp_vscode_step_7 from "../../../Images/mcp/vscode_step_7.png"
import mcp_vscode_step_8 from "../../../Images/mcp/vscode_step_8.png"
import mcp_vscode_step_9 from "../../../Images/mcp/vscode_step_9.png"
import mcp_vscode_step_10 from "../../../Images/mcp/vscode_step_10.png"
import mcp_consent_screen from "./mcp-doc/Images/consent-screen.png"

// MCP server endpoint shown in the setup snippets. Override per environment via
// REACT_APP_MCP_SERVER_URL; falls back to the feature-env (mcp-int) server.
const MCP_SERVER_URL =
  process.env.REACT_APP_MCP_SERVER_URL || "https://mcp.mcp-int.chargeback.io/mcp"

export const MCP_CARDS = [
  {
    key: "claude",
    title: "Claude",
    desc: "Connect Claude to explore your chargebacks, disputes, and recoveries in natural language.",
    icon: mcp_icon_claude,
    guide: "claude",
    missing: false
  },
  {
    key: "claude_code",
    title: "Claude Code",
    desc: "Connect Claude Code CLI to explore your chargebacks, disputes, and recoveries in natural language.",
    icon: mcp_icon_claude_code,
    guide: "claude_code",
    missing: false
  },
  {
    key: "chatgpt",
    title: "ChatGPT",
    desc: "Connect ChatGPT to explore your chargebacks, disputes, and recoveries in natural language.",
    icon: mcp_icon_chatgpt,
    icon_dark: mcp_icon_chatgpt_dark,
    guide: "chatgpt",
    missing: false
  },
  {
    key: "codex_by_openai",
    title: "Codex by OpenAI",
    desc: "Connect OpenAI Codex to explore your chargebacks, disputes, and recoveries in natural language.",
    icon: mcp_icon_codex_by_openai,
    guide: "codex",
    missing: false
  },
  {
    key: "grok",
    title: "Grok",
    desc: "Connect Grok to explore your chargebacks, disputes, and recoveries in natural language.",
    icon: mcp_icon_grok,
    icon_dark: mcp_icon_grok_dark,
    guide: "grok",
    missing: false
  },
  {
    key: "cursor",
    title: "Cursor",
    desc: "Connect Cursor to explore your chargebacks, disputes, and recoveries in natural language.",
    icon: mcp_icon_cursor,
    icon_dark: mcp_icon_cursor_dark,
    guide: "cursor",
    missing: false
  },
  // {
  //   "key": "github_copilot_in_vs_code",
  //   "title": "GitHub Copilot in VS Code",
  //   "desc": "Connect GitHub Copilot in VS Code to explore your chargebacks, disputes, and recoveries in natural language.",
  //   "icon": mcp_icon_github_copilot_in_vs_code,
  //   "guide": "vscode",
  //   "missing": false
  // },
  {
    key: "antigravity_ide",
    title: "Antigravity IDE",
    desc: "Connect Antigravity IDE to explore your chargebacks, disputes, and recoveries in natural language.",
    icon: mcp_icon_antigravity_ide,
    guide: "antigravity",
    missing: false
  },
  // {
  //   "key": "gemini_cli",
  //   "title": "Gemini CLI",
  //   "desc": "Connect Gemini CLI to explore your chargebacks, disputes, and recoveries in natural language.",
  //   "icon": mcp_icon_gemini_cli,
  //   "guide": "gemini",
  //   "missing": false
  // },
  {
    key: "devin_web",
    title: "Devin Web",
    desc: "Connect Devin Web to explore your chargebacks, disputes, and recoveries in natural language.",
    icon: mcp_icon_devin_web,
    guide: "devin",
    missing: false
  },
  {
    key: "mistral_ai",
    title: "Mistral AI",
    desc: "Connect Mistral AI to explore your chargebacks, disputes, and recoveries in natural language.",
    icon: mcp_icon_mistral_ai,
    guide: "mistral",
    missing: false
  },
  // {
  //   "key": "lovable",
  //   "title": "Lovable",
  //   "desc": "Connect Lovable to explore your chargebacks, disputes, and recoveries in natural language.",
  //   "icon": mcp_icon_lovable,
  //   "guide": "lovable",
  //   "missing": false
  // },
  // {
  //   "key": "bolt_new",
  //   "title": "Bolt.new",
  //   "desc": "Connect Bolt.new to explore your chargebacks, disputes, and recoveries in natural language.",
  //   "icon": mcp_icon_bolt_new,
  //   "guide": "bolt",
  //   "missing": false
  // },
  // {
  //   "key": "v0_by_vercel",
  //   "title": "v0 by Vercel",
  //   "desc": "Connect v0 by Vercel to explore your chargebacks, disputes, and recoveries in natural language.",
  //   "icon": mcp_icon_v0_by_vercel,
  //   "icon_dark": mcp_icon_v0_by_vercel_dark,
  //   "guide": "v0",
  //   "missing": false
  // },
  {
    key: "more_integrations",
    title: "More integrations",
    desc: "Using a tool not listed here? Follow the universal setup guide to connect any MCP-compatible client.",
    icon: mcp_icon_more_integrations,
    guide: "custom_mcp",
    missing: false
  },
  {
    key: "integration_missing",
    title: "Integration missing?",
    desc: "Let our team know which integration you are missing and we will add it as soon as possible.",
    icon: mcp_icon_integration_missing,
    guide: null,
    missing: true
  }
]

export const MCP_GUIDES = {
  claude: {
    title: "Connect Claude",
    subtitle: "Follow these steps in your Claude account",
    steps: [
      {
        blocks: [
          {
            type: "text",
            text: "In Claude, go to **Customize**, then **Connectors**."
          },
          {
            type: "callout",
            variant: "info",
            text: "If you're on a **Team or Enterprise plan**, an Owner must add the connector. If you don't see the option to add a connector, contact your workspace Owner."
          },
          {
            type: "image",
            src: mcp_claude_step_1
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Click **+** and select **Add custom connector**."
          },
          {
            type: "image",
            src: mcp_claude_step_2
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Enter a name you'll recognize later, like **Chargeback**. In the **Remote MCP server URL** field, paste the URL below:"
          },
          {
            type: "code",
            code: MCP_SERVER_URL
          },
          {
            type: "note",
            text: "Leave the OAuth fields empty, then click **Add**."
          },
          {
            type: "image",
            src: mcp_claude_step_3
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Click **Connect** to start the connection."
          },
          {
            type: "image",
            src: mcp_claude_step_4
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Keep all three permission boxes checked, then click **Allow**."
          },
          {
            type: "callout",
            variant: "success",
            text: "This connection has read-only access, plus one write permission: updating alert statuses."
          },
          {
            type: "note",
            text: "Already connected? Your existing connection may not have all these permissions yet. Disconnect and reconnect to grant them."
          },
          {
            type: "image",
            src: mcp_consent_screen
          }
        ]
      }
    ],
    disconnect: {
      subtitle: "Remove Chargeback's access to Claude",
      steps: [
        "In Claude, go to **Customize**, then **Connectors**.",
        "Find **Chargeback** in the list and click the **···** menu next to it.",
        "Click **Disconnect** to remove the connection."
      ],
      note: "Access is revoked immediately. You can reconnect at any time.",
      image: mcp_claude_disconnect
    },
    footer: {
      note: "Opens Claude in your browser",
      btn: "Open Claude",
      href: "https://claude.ai/new"
    }
  },
  chatgpt: {
    title: "Connect ChatGPT",
    subtitle: "Follow these steps in your ChatGPT account",
    steps: [
      {
        blocks: [
          {
            type: "text",
            text: "In ChatGPT, go to **Settings**, then **Plugins**."
          },
          {
            type: "callout",
            variant: "info",
            text: "If you're on a **Business or Enterprise workspace**, only an admin can turn on Developer mode. If you don't see it, contact your workspace admin."
          },
          {
            type: "image",
            src: mcp_chatgpt_step_1
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Ensure the **Permissions** settings align with your needs and click **Browse plugins**."
          },
          {
            type: "image",
            src: mcp_chatgpt_step_2
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Click the plus next to the **Search plugins** field. Enter a name you'll recognize later, like **Chargeback**. Under **Connection**, in the **Server URL** field, paste:"
          },
          {
            type: "code",
            code: MCP_SERVER_URL
          },
          {
            type: "text",
            text: "Leave the other settings at their defaults. If ChatGPT warns about the risk of custom MCP servers, confirm to continue, then click **Create**."
          },
          {
            type: "image",
            src: mcp_chatgpt_step_3
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Click **Sign in to continue**. ChatGPT sends you to Chargeback to sign in if you aren't already. Keep all three permission boxes checked, then click **Allow**."
          },
          {
            type: "callout",
            variant: "success",
            text: "This connection has read-only access, plus one write permission: updating alert statuses."
          },
          {
            type: "note",
            text: "Already connected? Your existing connection may not have all these permissions yet. Disconnect and reconnect to grant them."
          },
          {
            type: "image",
            src: mcp_consent_screen
          },
          {
            type: "callout",
            variant: "warning",
            text: "To use your custom connector data in your chat, please ensure the corresponding connector is pinned or enabled via the '+' menu inside the chat window."
          },
          {
            type: "callout",
            variant: "warning",
            text: "**Notice:** Due to a current ChatGPT issue, MCP tools may be discovered but not executed. If this happens, please retry the request using a Thinking model (e.g., GPT-5.5 Thinking Mini)."
          }
        ]
      }
    ],
    disconnect: {
      subtitle: "Remove Chargeback's access to ChatGPT",
      steps: [
        "In ChatGPT, open **Settings**.",
        "Go to **Plugins**.",
        "Find **Chargeback** in the list and open it. Select a needed action in the menu."
      ],
      note: "Access is revoked immediately. You can reconnect at any time.",
      image: mcp_chatgpt_disconnect
    },
    footer: {
      note: "Opens ChatGPT in your browser",
      btn: "Open ChatGPT",
      href: "https://chatgpt.com"
    }
  },
  codex: {
    title: "Connect Codex by OpenAI",
    subtitle: "Follow these steps in your Codex account",
    steps: [
      {
        blocks: [
          {
            type: "text",
            text: "In Codex, click your username at the bottom left, then go to **Settings** → **MCP servers**."
          },
          {
            type: "image",
            src: mcp_codex_step_1
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Click **+ Add server**."
          },
          {
            type: "image",
            src: mcp_codex_step_2
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Switch to **Streamable HTTP**. Enter a name you'll recognize later, like **Chargeback**. In the **Server URL** field, paste the URL below:"
          },
          {
            type: "code",
            code: MCP_SERVER_URL
          },
          {
            type: "note",
            text: "Leave all other settings at their defaults, then click **Save**."
          },
          {
            type: "image",
            src: mcp_codex_step_3
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "After saving, note the connector name shown in the list. You'll need it in the next step."
          },
          {
            type: "image",
            src: mcp_codex_step_4
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Start a new Codex chat and send this command (replace `chargeback` with your connector name if different):"
          },
          {
            type: "code",
            code: "Run outside sandbox: codex mcp login chargeback"
          },
          {
            type: "callout",
            variant: "info",
            text: "Codex will ask for approval to run outside the sandbox. Select **Yes** and click **Submit**."
          },
          {
            type: "image",
            src: mcp_codex_step_5
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Codex opens a browser window for Chargeback sign-in. Keep all three permission boxes checked, then click **Allow**."
          },
          {
            type: "callout",
            variant: "success",
            text: "This connection has read-only access, plus one write permission: updating alert statuses."
          },
          {
            type: "note",
            text: "Already connected? Your existing connection may not have all these permissions yet. Disconnect and reconnect to grant them."
          },
          {
            type: "image",
            src: mcp_consent_screen
          }
        ]
      }
    ],
    disconnect: {
      subtitle: "Remove Chargeback's access to Codex",
      steps: [
        "In Codex, open **Settings**.",
        "Go to **MCP servers**.",
        "Find **chargeback** in the list and toggle it off."
      ],
      note: "Access is revoked immediately. You can reconnect at any time.",
      image: mcp_codex_disconnect
    },
    footer: {
      note: "Opens Codex in your browser",
      btn: "Open Codex",
      href: "https://chatgpt.com/codex/"
    }
  },
  grok: {
    title: "Connect Grok",
    subtitle: "Follow these steps in your Grok account",
    steps: [
      {
        blocks: [
          {
            type: "text",
            text: "In Grok, go to **Skills and Connectors** in the sidebar, then select the **Connectors** tab."
          },
          {
            type: "callout",
            variant: "info",
            text: "MCP servers are supported across all Grok plans, but the **Free tier** may limit or disable MCP access. On **Business plans**, an admin may need to enable MCP access for the team."
          },
          {
            type: "image",
            src: mcp_grok_step_1
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Click **New Connector**."
          },
          {
            type: "image",
            src: mcp_grok_step_2
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Select **Custom**."
          },
          {
            type: "image",
            src: mcp_grok_step_3
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Enter a name you'll recognize later, like **Chargeback**. In the **Server URL** field, paste the URL below, then click **Add Connector**."
          },
          {
            type: "code",
            code: MCP_SERVER_URL
          },
          {
            type: "image",
            src: mcp_grok_step_4
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Grok sends you to Chargeback to sign in if you aren't already. Keep all three permission boxes checked, then click **Allow**."
          },
          {
            type: "callout",
            variant: "success",
            text: "This connection has read-only access, plus one write permission: updating alert statuses."
          },
          {
            type: "note",
            text: "Already connected? Your existing connection may not have all these permissions yet. Disconnect and reconnect to grant them."
          },
          {
            type: "image",
            src: mcp_consent_screen
          }
        ]
      }
    ],
    disconnect: {
      subtitle: "Remove Chargeback's access to Grok",
      steps: [
        "In Grok, go to **Skills and Connectors** in the sidebar, then select the **Connectors** tab.",
        "Find **Chargeback** in the list and click on it.",
        "Click **Disconnect** to remove the connection."
      ],
      note: "Access is revoked immediately. You can reconnect at any time.",
      image: mcp_grok_disconnect
    },
    footer: {
      note: "Opens Grok in your browser",
      btn: "Open Grok",
      href: "https://grok.com"
    }
  },
  cursor: {
    title: "Connect Cursor",
    subtitle: "Follow these steps in your Cursor app",
    steps: [
      {
        blocks: [
          {
            type: "text",
            text: "In Cursor, click your username at the bottom left, then go to **Settings** and select **Tools & MCPs**. Alternatively, navigate to **Settings** via the **Application menu --> Tools & MCPs**."
          },
          {
            type: "callout",
            variant: "info",
            text: "MCP servers are available on all Cursor plans, but the **Free tier** may limit or disable MCP access. On a **Business plan**, an admin must enable MCP access for the team."
          },
          {
            type: "image",
            src: mcp_cursor_step_1
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Click **Add Custom MCP**. Cursor will open your `mcp.json` config file."
          },
          {
            type: "image",
            src: mcp_cursor_step_2
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Paste the following into the config panel and save the file:"
          },
          {
            type: "code",
            code: `{
  "mcpServers": {
    "Chargeback": {
      "command": "npx",
      "args": ["-y", "mcp-remote@latest", "${MCP_SERVER_URL}"]
    }
  }
}`
          },
          {
            type: "image",
            src: mcp_cursor_step_3
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Cursor opens a browser window for Chargeback sign-in. Keep all three permission boxes checked, then click **Allow**."
          },
          {
            type: "callout",
            variant: "success",
            text: "This connection has read-only access, plus one write permission: updating alert statuses."
          },
          {
            type: "note",
            text: "Already connected? Your existing connection may not have all these permissions yet. Disconnect and reconnect to grant them."
          },
          {
            type: "image",
            src: mcp_consent_screen
          }
        ]
      }
    ],
    disconnect: {
      subtitle: "Remove Chargeback's access to Cursor",
      steps: [
        "In Cursor, go to **Settings** → **Tools & MCPs**.",
        "Find **Chargeback** under Home MCP Servers and hover over it to reveal the available actions.",
        "Click the **trash icon** to select **Delete MCP server** and confirm."
      ],
      note: "Access is revoked immediately. You can reconnect at any time.",
      image: mcp_cursor_disconnect
    },
    footer: {
      note: "Opens Cursor in your browser",
      btn: "Open Cursor",
      href: "https://cursor.com"
    }
  },
  vscode: {
    title: "Connect GitHub Copilot in VS Code",
    subtitle: "Follow these steps in VS Code with GitHub Copilot",
    steps: [
      {
        blocks: [
          {
            type: "text",
            text: "In VS Code, open the Copilot chat panel and click **Customizations** → **MCP Servers** in the sidebar."
          },
          {
            type: "callout",
            variant: "info",
            text: 'Available on **all GitHub Copilot plans**, including the free tier. On a **Business or Enterprise plan**, an admin must enable the "MCP servers in Copilot" policy for the organization.'
          },
          {
            type: "image",
            src: mcp_vscode_step_1
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "In the **Agent Customizations** dialog, click the **MCP Servers** card or select **MCP Servers** in the left sidebar."
          },
          {
            type: "image",
            src: mcp_vscode_step_2
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Click the **+** button next to **Browse Marketplace** to add a new server."
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "In the dropdown, select **HTTP (HTTP or Server-Sent Events)**."
          },
          {
            type: "image",
            src: mcp_vscode_step_4
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Paste the server URL and press **Enter**:"
          },
          {
            type: "code",
            code: MCP_SERVER_URL
          },
          {
            type: "image",
            src: mcp_vscode_step_5
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Enter a name you'll recognize later, like `Chargeback`, then press **Enter**."
          },
          {
            type: "image",
            src: mcp_vscode_step_6
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Choose your preferred **Configuration target**. Select **Global** to make it available in all workspaces."
          },
          {
            type: "image",
            src: mcp_vscode_step_7
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "VS Code asks if the MCP server can authenticate. Click **Allow**."
          },
          {
            type: "image",
            src: mcp_vscode_step_8
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Select **Sign in to another account**, then confirm opening the external website."
          },
          {
            type: "image",
            src: mcp_vscode_step_9
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "VS Code opens a browser window for Chargeback sign-in. Keep all three permission boxes checked, then click **Allow**."
          },
          {
            type: "callout",
            variant: "success",
            text: "The connection can read your data and, only with your confirmation, update alert statuses. Everything else stays read-only, and you can revoke access at any time."
          },
          {
            type: "note",
            text: "Already connected? Existing connections don't get this new permission automatically. Disconnect and reconnect to grant it."
          },
          {
            type: "image",
            src: mcp_vscode_step_10
          }
        ]
      }
    ],
    disconnect: {
      subtitle: "Remove Chargeback's access to GitHub Copilot",
      steps: [
        "In your Copilot IDE, open **Agent Customizations** and go to **MCP Servers**.",
        "Find **chargeback** and right-click (or click the dropdown) to reveal available actions.",
        "Select **Uninstall** to fully remove, or **Disconnect Account (MCP)** to revoke OAuth only."
      ],
      note: "Access is revoked immediately. You can reconnect at any time.",
      image: mcp_vscode_disconnect
    },
    footer: {
      note: "Opens VS Code in your browser",
      btn: "Open VS Code",
      href: "https://code.visualstudio.com"
    }
  },
  antigravity: {
    title: "Connect Antigravity IDE",
    subtitle: "Follow these steps in your Antigravity IDE",
    steps: [
      {
        blocks: [
          {
            type: "text",
            text: "In the **Agent** panel, click the **···** icon to open Additional Options, then select **MCP Servers**."
          },
          {
            type: "callout",
            variant: "info",
            text: "MCP servers are supported across all Antigravity plans, but the **Free tier** may limit or disable MCP access. On an **Organization plan**, an admin may need to enable MCP access for the team."
          },
          {
            type: "image",
            src: mcp_antigravity_step_1
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "In the **Manage MCP servers** page, click **View raw config**."
          },
          {
            type: "image",
            src: mcp_antigravity_step_2
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Paste the following JSON into the config file, then save with `Cmd+S` (macOS) or `Ctrl+S` (Windows):"
          },
          {
            type: "code",
            code: `{
  "mcpServers": {
    "Chargeback": {
      "command": "npx",
      "args": ["-y", "mcp-remote@latest", "${MCP_SERVER_URL}"]
    }
  }
}`
          },
          {
            type: "image",
            src: mcp_antigravity_step_3
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Switch back to the **Manage MCPs** tab and click **Refresh** to confirm the server is connected."
          },
          {
            type: "image",
            src: mcp_antigravity_step_4
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Antigravity IDE opens a browser window for Chargeback sign-in. Keep all three permission boxes checked, then click **Allow**."
          },
          {
            type: "callout",
            variant: "success",
            text: "This connection has read-only access, plus one write permission: updating alert statuses."
          },
          {
            type: "note",
            text: "Already connected? Your existing connection may not have all these permissions yet. Disconnect and reconnect to grant them."
          },
          {
            type: "image",
            src: mcp_consent_screen
          }
        ]
      }
    ],
    disconnect: {
      subtitle: "Remove Chargeback's access to Antigravity",
      steps: [
        "In Antigravity, click the **···** menu at the top of the agent panel.",
        "Select **MCP Servers**, then click **Manage MCP Servers**.",
        "Find **Chargeback** and toggle off the **Enabled** switch."
      ],
      note: "Access is revoked immediately. You can reconnect at any time.",
      image: mcp_antigravity_disconnect
    },
    footer: {
      note: "Opens Antigravity IDE in your browser",
      btn: "Open Antigravity IDE",
      href: "https://antigravity.google/product/antigravity-ide"
    }
  },
  lovable: {
    title: "Connect Lovable",
    subtitle: "Follow these steps in Lovable",
    steps: [
      {
        blocks: [
          {
            type: "text",
            text: "In **Lovable**, go to **Connectors** in the sidebar."
          },
          {
            type: "callout",
            variant: "info",
            text: "MCP servers are supported across all Lovable plans, but the **Free tier** may limit or disable MCP access. On an **Enterprise plan**, an admin may need to enable MCP access for the team."
          },
          {
            type: "image",
            src: mcp_lovable_step_1
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "In the **Connectors** list, scroll down and pick **Custom**."
          },
          {
            type: "image",
            src: mcp_lovable_step_2
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Enter a name you'll recognize later, like **Chargeback**. In the **Server URL** field, paste the URL below:"
          },
          {
            type: "code",
            code: MCP_SERVER_URL
          },
          {
            type: "note",
            text: "Leave **OAuth** selected by default, then click **Add & authorize**."
          },
          {
            type: "image",
            src: mcp_lovable_step_3
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Lovable sends you to Chargeback to sign in if you aren't already. Keep all three permission boxes checked, then click **Allow**."
          },
          {
            type: "callout",
            variant: "success",
            text: "This connection can read your data and, only with your confirmation, update alert statuses. Everything else stays read-only, and you can revoke access at any time."
          },
          {
            type: "note",
            text: "Already connected? Existing connections don't get this new permission automatically. Disconnect and reconnect to grant it."
          },
          {
            type: "image",
            src: mcp_lovable_step_4
          }
        ]
      }
    ],
    disconnect: {
      subtitle: "Remove Chargeback's access to Lovable",
      steps: [
        "In Lovable, go to **Connectors** in the sidebar.",
        "Find **Chargeback** in the list.",
        "Click **Disconnect**."
      ],
      note: "Access is revoked immediately. You can reconnect at any time.",
      image: mcp_lovable_disconnect
    },
    footer: {
      note: "Opens Lovable in your browser",
      btn: "Open Lovable",
      href: "https://lovable.dev/dashboard"
    }
  },
  bolt: {
    title: "Connect Bolt.new",
    subtitle: "Follow these steps in Bolt.new",
    steps: [
      {
        blocks: [
          {
            type: "text",
            text: "In **Bolt.new**, go to **Settings**."
          },
          {
            type: "callout",
            variant: "info",
            text: "MCP servers are supported across all Bolt plans, but the **Free tier** may limit or disable MCP access. On a **Team plan**, an admin may need to enable MCP access for the team."
          },
          {
            type: "image",
            src: mcp_bolt_step_1
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Go to **Connectors (MCP)** and click **Custom MCP server**."
          },
          {
            type: "image",
            src: mcp_bolt_step_2
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Enter a name you'll recognize later, like **Chargeback**. In the **URL** field, paste the URL below:"
          },
          {
            type: "code",
            code: MCP_SERVER_URL
          },
          {
            type: "note",
            text: "For the **Transport Type** select **HTTP** and set **Authentication** to **MCP OAuth**."
          },
          {
            type: "image",
            src: mcp_bolt_step_3
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Bolt.new sends you to Chargeback to sign in if you aren't already. Keep all three permission boxes checked, then click **Allow**."
          },
          {
            type: "callout",
            variant: "success",
            text: "This connection can read your data and, only with your confirmation, update alert statuses. Everything else stays read-only, and you can revoke access at any time."
          },
          {
            type: "note",
            text: "Already connected? Existing connections don't get this new permission automatically. Disconnect and reconnect to grant it."
          },
          {
            type: "image",
            src: mcp_bolt_step_4
          },
          {
            type: "callout",
            variant: "warning",
            text: "To use MCP server data in your chat, please ensure the corresponding connector is enabled inside the project chat."
          }
        ]
      }
    ],
    disconnect: {
      subtitle: "Remove Chargeback's access to Bolt.new",
      steps: [
        "In Bolt.new, go to **Settings**, then **Connectors (MCP)**.",
        "Find **Chargeback** in the list.",
        "Click the **···** menu and select **Disconnect**."
      ],
      note: "Access is revoked immediately. You can reconnect at any time.",
      image: mcp_bolt_disconnect
    },
    footer: {
      note: "Opens Bolt.new in your browser",
      btn: "Open Bolt.new",
      href: "https://bolt.new"
    }
  },
  v0: {
    title: "Connect v0 by Vercel",
    subtitle: "Follow these steps in v0",
    steps: [
      {
        blocks: [
          {
            type: "text",
            text: "In **v0**, go to **Account Settings**."
          },
          {
            type: "callout",
            variant: "info",
            text: "Available on all v0 plans, including the free tier (which includes $5 of monthly credits). Heavier MCP usage may require a **paid plan**."
          },
          {
            type: "image",
            src: mcp_v0_step_1
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Go to **Integrations**, then click **Add MCP**."
          },
          {
            type: "image",
            src: mcp_v0_step_2
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Select **Custom MCP**."
          },
          {
            type: "image",
            src: mcp_v0_step_3
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Enter a name you'll recognize later, like **Chargeback**. In the **URL** field, paste the URL below:"
          },
          {
            type: "code",
            code: MCP_SERVER_URL
          },
          {
            type: "note",
            text: "Set **Authentication** to **OAuth**."
          },
          {
            type: "image",
            src: mcp_v0_step_4
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "v0 sends you to Chargeback to sign in if you aren't already. Keep all three permission boxes checked, then click **Allow**."
          },
          {
            type: "callout",
            variant: "success",
            text: "This connection can read your data and, only with your confirmation, update alert statuses. Everything else stays read-only, and you can revoke access at any time."
          },
          {
            type: "note",
            text: "Already connected? Existing connections don't get this new permission automatically. Disconnect and reconnect to grant it."
          },
          {
            type: "image",
            src: mcp_v0_step_5
          }
        ]
      }
    ],
    disconnect: {
      subtitle: "Remove Chargeback's access to v0",
      steps: [
        "In v0, go to **Account Settings**, then **Integrations**.",
        "Find **Chargeback** in the list.",
        "Click the **···** menu and select **Delete MCP**."
      ],
      note: "Access is revoked immediately. You can reconnect at any time.",
      image: mcp_v0_disconnect
    },
    footer: {
      note: "Opens v0 in your browser",
      btn: "Open v0",
      href: "https://v0.dev"
    }
  },
  devin: {
    title: "Connect Devin Web",
    subtitle: "Follow these steps in Devin Web App",
    steps: [
      {
        blocks: [
          {
            type: "text",
            text: "In **Devin Web App**, go to **Settings**."
          },
          {
            type: "callout",
            variant: "info",
            text: "MCP servers are available on all Devin plans, i but the **Free tier** may limit or disable MCP access. On **Business plans**, an admin may need to enable MCP access for the team."
          },
          {
            type: "image",
            src: mcp_devin_step_1
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Go to **Connections**, then open the **MCP servers** tab."
          },
          {
            type: "image",
            src: mcp_devin_step_2
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Click **Add a custom MCP**."
          },
          {
            type: "image",
            src: mcp_devin_step_3
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "For **Server name**, enter a name you'll recognize later, like **Chargeback**. Fill in the **Short description** field with the text below:"
          },
          {
            type: "code",
            code: "Connecting an AI agent via MCP server enables accessing main information from Chargeback platform and get some related assistance."
          },
          {
            type: "image",
            src: mcp_devin_step_4
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Below, set **Transport type** to **HTTP** and **Authentication** to **OAuth**. In the **Server URL** field, paste the URL below:"
          },
          {
            type: "code",
            code: MCP_SERVER_URL
          },
          {
            type: "note",
            text: "Then click **Install and enable**. If Devin warns about the risk of custom MCP servers, confirm to continue."
          },
          {
            type: "image",
            src: mcp_devin_step_5
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Click **Complete OAuth**."
          },
          {
            type: "image",
            src: mcp_devin_step_6
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Devin sends you to Chargeback to sign in if you aren't already. Keep all three permission boxes checked, then click **Allow**."
          },
          {
            type: "callout",
            variant: "success",
            text: "This connection has read-only access, plus one write permission: updating alert statuses."
          },
          {
            type: "note",
            text: "Already connected? Your existing connection may not have all these permissions yet. Disconnect and reconnect to grant them."
          },
          {
            type: "image",
            src: mcp_consent_screen
          }
        ]
      }
    ],
    disconnect: {
      subtitle: "Remove Chargeback's access to Devin",
      steps: [
        "In Devin, go to **Settings** → **Connections**, then the **MCP servers** tab.",
        "Find **Chargeback** in the list of connected MCP servers.",
        "Open Chargeback MCP settings and click **Delete MCP**."
      ],
      note: "Access is revoked immediately. You can reconnect at any time.",
      image: mcp_devin_disconnect
    },
    footer: {
      note: "Opens Devin Web in your browser",
      btn: "Open Devin Web",
      href: "https://app.devin.ai"
    }
  },
  gemini: {
    title: "Connect Gemini CLI",
    subtitle: "Run commands in your terminal",
    intro: [
      {
        type: "callout",
        variant: "info",
        text: "**Precondition:** Gemini CLI is already installed and you've launched it at least once. Gemini CLI is **free**, no paid plan required."
      }
    ],
    variants: [
      {
        label: "Mac",
        steps: [
          {
            blocks: [
              {
                type: "text",
                text: "Run this in Terminal to see what's already in your config file:"
              },
              {
                type: "code",
                code: "cat ~/.gemini/settings.json"
              },
              {
                type: "note",
                text: "You'll see something like this, take note of the content:"
              },
              {
                type: "code",
                code: `{"security":{"auth":{"selectedType":"oauth-personal"}}}`
              }
            ]
          },
          {
            blocks: [
              {
                type: "text",
                text: "Paste this entire block into Terminal and press Return. It writes the config file, keeping your existing settings:"
              },
              {
                type: "code",
                code: `cat > ~/.gemini/settings.json << 'EOF'
{
  "security": {
    "auth": {
      "selectedType": "oauth-personal"
    }
  },
  "mcpServers": {
    "chargeback_dev": {
      "httpUrl": "${MCP_SERVER_URL}"
    }
  }
}

EOF`
              },
              {
                type: "callout",
                variant: "warning",
                text: "If your settings file had different content in Step 1, make sure to include it in this command too, otherwise you'll lose those settings."
              },
              {
                type: "callout",
                variant: "info",
                text: "If Step 1 gave an error saying the file doesn't exist, run this first: `mkdir -p ~/.gemini`"
              }
            ]
          },
          {
            blocks: [
              {
                type: "text",
                text: "Verify the file:"
              },
              {
                type: "code",
                code: "cat ~/.gemini/settings.json"
              },
              {
                type: "note",
                text: "You should see both your original settings and the mcpServers block. If the file looks empty or broken, redo Step 2."
              }
            ]
          },
          {
            blocks: [
              {
                type: "text",
                text: "Start Gemini CLI:"
              },
              {
                type: "code",
                code: "gemini"
              },
              {
                type: "callout",
                variant: "info",
                text: "If Gemini CLI was already open, type `/quit` to exit it first, then run `gemini` again. The config is only loaded on startup."
              }
            ]
          },
          {
            blocks: [
              {
                type: "text",
                text: "Inside the Gemini CLI session, type this and press Return:"
              },
              {
                type: "code",
                code: "/mcp auth chargeback_dev"
              },
              {
                type: "note",
                text: "Your browser opens automatically to sign in to your Chargeback account if you aren't already. Keep all three permission boxes checked, then click **Allow**."
              },
              {
                type: "callout",
                variant: "success",
                text: "This connection can read your data and, only with your confirmation, update alert statuses. Everything else stays read-only, and you can revoke access at any time."
              },
              {
                type: "note",
                text: "Already connected? Existing connections don't get this new permission automatically. Disconnect and reconnect to grant it."
              },
              {
                type: "image",
                src: mcp_gemini_step_5
              }
            ]
          },
          {
            blocks: [
              {
                type: "text",
                text: "Confirm it's connected:"
              },
              {
                type: "code",
                code: "/mcp list"
              },
              {
                type: "note",
                text: "`chargeback_dev` should show as **Connected**. You're all set."
              }
            ]
          }
        ]
      },
      {
        label: "Linux",
        steps: [
          {
            blocks: [
              {
                type: "text",
                text: "Run this in your terminal to see what's already in your config file:"
              },
              {
                type: "code",
                code: "cat ~/.gemini/settings.json"
              },
              {
                type: "note",
                text: "You'll see something like this, take note of the content:"
              },
              {
                type: "code",
                code: `{"security":{"auth":{"selectedType":"oauth-personal"}}}`
              }
            ]
          },
          {
            blocks: [
              {
                type: "text",
                text: "Paste this entire block into your terminal and press Enter:"
              },
              {
                type: "code",
                code: `cat > ~/.gemini/settings.json << 'EOF'
{
  "security": {
    "auth": {
      "selectedType": "oauth-personal"
    }
  },
  "mcpServers": {
    "chargeback_dev": {
      "httpUrl": "${MCP_SERVER_URL}"
    }
  }
}
EOF`
              },
              {
                type: "callout",
                variant: "warning",
                text: "If your settings file had different content in Step 1, make sure to include it in this command too, otherwise you'll lose those settings."
              },
              {
                type: "callout",
                variant: "info",
                text: "If Step 1 gave an error saying the file doesn't exist, run this first: `mkdir -p ~/.gemini`"
              }
            ]
          },
          {
            blocks: [
              {
                type: "text",
                text: "Verify the file:"
              },
              {
                type: "code",
                code: "cat ~/.gemini/settings.json"
              },
              {
                type: "note",
                text: "You should see both your original settings and the mcpServers block. If the file looks empty or broken, redo Step 2."
              }
            ]
          },
          {
            blocks: [
              {
                type: "text",
                text: "Start Gemini CLI:"
              },
              {
                type: "code",
                code: "gemini"
              },
              {
                type: "callout",
                variant: "info",
                text: "If Gemini CLI was already running, type `/quit` first, then run `gemini` again. Config is only loaded on startup."
              }
            ]
          },
          {
            blocks: [
              {
                type: "text",
                text: "Inside the Gemini CLI session, type this and press Return:"
              },
              {
                type: "code",
                code: "/mcp auth chargeback_dev"
              },
              {
                type: "note",
                text: "Your browser opens automatically to sign in to your Chargeback account if you aren't already. Keep all three permission boxes checked, then click **Allow**."
              },
              {
                type: "callout",
                variant: "success",
                text: "This connection can read your data and, only with your confirmation, update alert statuses. Everything else stays read-only, and you can revoke access at any time."
              },
              {
                type: "note",
                text: "Already connected? Existing connections don't get this new permission automatically. Disconnect and reconnect to grant it."
              },
              {
                type: "callout",
                variant: "warning",
                text: "On headless Linux servers (no desktop/browser), OAuth won't work directly. You'll need a browser on your machine to complete this step."
              },
              {
                type: "image",
                src: mcp_gemini_step_5
              }
            ]
          },
          {
            blocks: [
              {
                type: "text",
                text: "Confirm it's connected:"
              },
              {
                type: "code",
                code: "/mcp list"
              },
              {
                type: "note",
                text: "`chargeback_dev` should show as **Connected**. You're all set."
              }
            ]
          }
        ]
      },
      {
        label: "Windows",
        steps: [
          {
            blocks: [
              {
                type: "text",
                text: "Open PowerShell and run:"
              },
              {
                type: "code",
                code: `type "$env:USERPROFILE\\.gemini\\settings.json"`
              },
              {
                type: "note",
                text: "You'll see something like this, take note of the content:"
              },
              {
                type: "code",
                code: `{"security":{"auth":{"selectedType":"oauth-personal"}}}`
              },
              {
                type: "callout",
                variant: "info",
                text: 'If you get a "cannot find the path" error, that\'s fine, just continue to Step 2.'
              }
            ]
          },
          {
            blocks: [
              {
                type: "text",
                text: "In PowerShell, run this to create the config folder (safe to run even if it already exists):"
              },
              {
                type: "code",
                code: `New-Item -ItemType Directory -Force -Path "$env:USERPROFILE\\.gemini"`
              },
              {
                type: "text",
                text: "Then write the settings file by pasting this whole block and pressing Enter:"
              },
              {
                type: "code",
                code: `@'
{
  "security": {
    "auth": {
      "selectedType": "oauth-personal"
    }
  },
  "mcpServers": {
    "chargeback_dev": {
      "httpUrl": "${MCP_SERVER_URL}"
    }
  }
}
'@ | Set-Content "$env:USERPROFILE\\.gemini\\settings.json" -Encoding UTF8`
              },
              {
                type: "callout",
                variant: "warning",
                text: "If your settings file had different content in Step 1, include it in the JSON above, otherwise you'll overwrite it."
              }
            ]
          },
          {
            blocks: [
              {
                type: "text",
                text: "Verify the file:"
              },
              {
                type: "code",
                code: `type "$env:USERPROFILE\\.gemini\\settings.json"`
              },
              {
                type: "note",
                text: "You should see both your original settings and the mcpServers block. If not, redo Step 2."
              }
            ]
          },
          {
            blocks: [
              {
                type: "text",
                text: "Start Gemini CLI:"
              },
              {
                type: "code",
                code: "gemini"
              },
              {
                type: "callout",
                variant: "info",
                text: "If Gemini CLI was already open, type `/quit` to exit it first, then run `gemini` again. Config is only loaded on startup."
              }
            ]
          },
          {
            blocks: [
              {
                type: "text",
                text: "Inside the Gemini CLI session, type this and press Enter:"
              },
              {
                type: "code",
                code: "/mcp auth chargeback_dev"
              },
              {
                type: "note",
                text: "Your browser opens automatically to sign in to your Chargeback account if you aren't already. Keep all three permission boxes checked, then click **Allow**."
              },
              {
                type: "callout",
                variant: "success",
                text: "This connection can read your data and, only with your confirmation, update alert statuses. Everything else stays read-only, and you can revoke access at any time."
              },
              {
                type: "note",
                text: "Already connected? Existing connections don't get this new permission automatically. Disconnect and reconnect to grant it."
              },
              {
                type: "image",
                src: mcp_gemini_step_5
              }
            ]
          },
          {
            blocks: [
              {
                type: "text",
                text: "Confirm it's connected:"
              },
              {
                type: "code",
                code: "/mcp list"
              },
              {
                type: "note",
                text: "`chargeback_dev` should show as **Connected**. You're all set."
              }
            ]
          }
        ]
      }
    ],
    disconnect: {
      subtitle: "Remove Chargeback's access to Gemini CLI",
      blocks: [
        {
          type: "text",
          weight: "regular",
          text: "1. First, confirm Chargeback appears in your configured servers:"
        },
        {
          type: "code",
          code: "gemini mcp list"
        },
        {
          type: "spacer"
        },
        {
          type: "text",
          weight: "regular",
          text: "2. Then remove it:"
        },
        {
          type: "code",
          code: "gemini mcp remove chargeback"
        },
        {
          type: "callout",
          variant: "info",
          text: "If still listed, try `gemini mcp remove chargeback -s user` to target the user-scoped config."
        }
      ],
      note: "Access is revoked immediately. You can reconnect at any time."
    },
    footer: {
      note: "Opens Gemini CLI docs in your browser",
      btn: "Gemini CLI docs",
      href: "https://github.com/google-gemini/gemini-cli"
    }
  },
  custom_mcp: {
    title: "More integrations",
    subtitle: "Universal setup for any MCP-compatible tool",
    intro: [
      {
        type: "callout",
        variant: "info",
        text: "Your tool must support **remote MCP servers over HTTP with OAuth**. This is the standard way most modern AI coding and chat tools connect to external MCP servers."
      }
    ],
    steps: [
      {
        blocks: [
          {
            type: "text",
            text: "In your tool, find the MCP or integrations settings, usually under **Settings → Integrations**, **Connectors**, or **MCP Servers**."
          },
          {
            type: "callout",
            variant: "info",
            text: "Look for an option to add a **remote**, **custom**, or **HTTP** MCP server. Local (stdio/command-based) servers won't work here."
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Add a new server with these details:"
          },
          {
            type: "fields",
            rows: [
              { label: "Name", value: "Anything you'll recognise, e.g. **Chargeback**" },
              { label: "URL", code: MCP_SERVER_URL },
              { label: "Transport", value: "**HTTP** (also called Streamable HTTP)" },
              { label: "Auth", value: "**OAuth**" }
            ]
          },
          {
            type: "code",
            code: MCP_SERVER_URL,
            label: "Copy the URL:"
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Save or confirm. Your tool will redirect you to Chargeback to sign in."
          },
          {
            type: "callout",
            variant: "info",
            text: "If your tool doesn't redirect automatically, look for a **Connect**, **Authorize**, or **Complete OAuth** button after saving."
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Keep all three permission boxes checked, then click **Allow**."
          },
          {
            type: "callout",
            variant: "success",
            text: "This connection has read-only access, plus one write permission: updating alert statuses."
          },
          {
            type: "note",
            text: "Already connected? Your existing connection may not have all these permissions yet. Disconnect and reconnect to grant them."
          },
          {
            type: "image",
            src: mcp_consent_screen
          },
          {
            type: "callout",
            variant: "warning",
            text: "If your tool requires a bearer token instead of OAuth, this isn't currently supported. Check back later or use one of the tools listed above."
          }
        ]
      }
    ]
  },
  mistral: {
    title: "Connect Mistral AI",
    subtitle: "Follow these steps in your Mistral AI account",
    steps: [
      {
        blocks: [
          {
            type: "text",
            text: "In Mistral AI, go to **Context**, then **Connectors**."
          },
          {
            type: "callout",
            variant: "info",
            text: "MCP servers are supported across all Mistral plans, but the **Free tier** may limit or disable MCP access. On a **Team plan**, an admin may need to enable MCP access for the team."
          },
          {
            type: "image",
            src: mcp_mistral_step_1
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Click **Add Connector**."
          },
          {
            type: "image",
            src: mcp_mistral_step_2
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Switch to **Custom MCP Connector** and enter a name you'll recognize later, like **Chargeback**. In the **Connector Server** field, paste:"
          },
          {
            type: "code",
            code: MCP_SERVER_URL
          },
          {
            type: "note",
            text: "Leave the other settings at their defaults."
          },
          {
            type: "image",
            src: mcp_mistral_step_3
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Mistral AI sends you to Chargeback to sign in if you aren't already. Keep all three permission boxes checked, then click **Allow**."
          },
          {
            type: "callout",
            variant: "success",
            text: "This connection has read-only access, plus one write permission: updating alert statuses."
          },
          {
            type: "note",
            text: "Already connected? Your existing connection may not have all these permissions yet. Disconnect and reconnect to grant them."
          },
          {
            type: "image",
            src: mcp_consent_screen
          }
        ]
      }
    ],
    disconnect: {
      subtitle: "Remove Chargeback's access to Mistral AI",
      steps: [
        "In Mistral AI, go to **Context**, then **Connectors**.",
        "Find **Chargeback** in the list and click on it.",
        "Open the dropdown next to **New Chat** and select **Disconnect**."
      ],
      note: "Access is revoked immediately. You can reconnect at any time.",
      image: mcp_mistral_disconnect
    },
    footer: {
      note: "Opens Mistral AI in your browser",
      btn: "Open Mistral AI",
      href: "https://chat.mistral.ai"
    }
  },
  claude_code: {
    title: "Connect Claude Code",
    subtitle: "Run these commands in your terminal",
    intro: [
      {
        type: "callout",
        variant: "info",
        text: "Works with **Claude Code CLI**. For **Claude Code Desktop** or **Claude Code Web**, follow the Claude guide."
      }
    ],
    steps: [
      {
        blocks: [
          {
            type: "text",
            text: "In your Terminal, run this command:"
          },
          {
            type: "code",
            code: `claude mcp add --transport http chargeback ${MCP_SERVER_URL}`
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "After adding the MCP server, trigger the authentication with Chargeback with the command:"
          },
          {
            type: "code",
            code: `claude /mcp`
          }
        ]
      },
      {
        blocks: [
          {
            type: "text",
            text: "Claude Code sends you to Chargeback to sign in if you aren't already. Keep all three permission boxes checked, then click **Allow**."
          },
          {
            type: "callout",
            variant: "success",
            text: "This connection has read-only access, plus one write permission: updating alert statuses."
          },
          {
            type: "note",
            text: "Already connected? Your existing connection may not have all these permissions yet. Disconnect and reconnect to grant them."
          },
          {
            type: "image",
            src: mcp_consent_screen
          }
        ]
      }
    ],
    disconnect: {
      subtitle: "Remove Chargeback's access to Claude Code",
      blocks: [
        {
          type: "text",
          text: "Run this command in your terminal:"
        },
        {
          type: "code",
          code: "claude mcp remove chargeback"
        },
        {
          type: "callout",
          variant: "info",
          text: "If Chargeback still shows up after this, you may have a second entry under a different name (e.g. `chargeback_dev`). Run `claude mcp list` to find it, then `claude mcp remove <name>` to remove it."
        }
      ]
    },
    footer: {
      note: "Opens Claude Code in your browser",
      btn: "Open Claude Code",
      href: "https://claude.ai/code"
    }
  }
}
